<template>
  <div>
    <div v-if="!loading && data.categories[currentCategory]">
      <!-- Row top buttons -->
      <div class="row q-mb-lg">
        <div class="col-6" style="justify-content: flex-start">
          <q-btn class="capitalize ctrl-button" color="grey-5" :label="`${$store.state.stringsStore.strings.action.toOverview}`" @click="$router.push('/spare-parts')" icon="keyboard_backspace" />
        </div>
        <div class="col-6">
          <SparePartsLogsModal />
          <q-btn style="float: right" class="capitalize ctrl-button right q-ml-md" :color="readOnly ? 'grey-5' : 'ctrl-turquoise'" :label="readOnly
            ? $store.state.stringsStore.strings.action.edit
            : $store.state.stringsStore.strings.action.save
            " @click="save()" :icon-right="readOnly ? 'edit' : 'save'" />
          <q-toggle style="float: right" class="q-pt-sm" v-model="data.is_active" :disable="readOnly" color="secondary" left-label :false-value="0" :true-value="1" label="Activated" />
        </div>
      </div>

      <!-- Columns -->
      <div class="row gutter-sm q-mb-lg">
        <!-- Left -->
        <div class="col-md-5 col-sm-12 col-xs-12 q-pa-sm">
          <div class="card-block full q-mb-md">
            <!-- Readonly item reference -->
            <q-field>
              <q-input v-model="data.reference" readonly class="q-mb-md" float-label="Reference" />
            </q-field>
            <!-- item input autocomplete for the item code  -->
            <q-field>
              <q-search type="text" v-model="itemCode" placeholder="Item" class="q-mb-md" float-label="Item" :disabled="readOnly">
                <q-autocomplete :max-results="25" :min-characters="2" @search="searchItems" @selected="selected(...arguments)" />
              </q-search>
            </q-field>
            <!-- batch number readonly -->
            <q-field>
              <q-input v-model="data.batch_number" readonly class="q-mb-md" :float-label="getString(null, 'Batch Number', 'Batch Nummer')" />
            </q-field>
            <!-- is_delivered toggle readonly -->
            <q-field class="q-mt-sm">
              {{ getString(null, "Delivered", "Geleverd") }} <q-toggle v-model="data.is_delivered" color="primary" readonly class="q-ml-md" float-label="Is Delivered" />
            </q-field>
          </div>

          <div class="card-block full-width spareparts-reference__left">

            <div class="row q-mb-md">
              <div class="spareparts-reference__category" :class="{
                'col-6': data.categories.length === 2,
                'col-4': data.categories.length === 3,
                'col-3': data.categories.length === 4,
                'col-2': data.categories.length > 4,
                'spareparts-reference__category--active':
                  index === currentCategory,
              }" :key="`${index}-${category.id}`" @click="selectCategory(index)" v-for="(category, index) in data.categories">
                <!-- evenly sized divs spanning the width of the container -->
                {{ data.categories.length > 2 ? category.label.replace('parts', '') : category.label }}
              </div>
            </div>

            <div class="row">
              <!-- bordered image -->
              <div class="col-12">
                <img :src="categoryImage" :alt="data.name" class="spareparts-reference__image" />
              </div>
            </div>
          </div>
        </div>
        <!-- Right -->
        <div class="col-md-7 col-sm-12 col-xs-12 q-pl-sm">
          <div class="row q-mb-sm">
            <div class="card-block full-width" style="padding: 10px;">

              <!-- headers for the columns -->
              <div class="row spareparts-reference__row--header">
                <div class="col-1">
                  <!-- <span class="text-h6">Status</span> -->
                </div>
                <div class="col-1">
                  <span class="text-h6">Num</span>
                </div>
                <div class="col-2">
                  <span class="text-h6">Code</span>
                </div>
                <div class="col-6">
                  <span class="text-h6">Name</span>
                </div>
                <div class="col-1">
                  <span class="text-h6">Qty</span>
                </div>
              </div>

              <div v-for="item in data.categories[currentCategory].items" :key="item.id" class="row spareparts-reference__row" @click="openItemModal(item)">
                <div class="col-1">
                  <dot-status class="q-ml-sm" :class="item.has_item ? 'show-status--green' : 'show-status'">
                    <template v-slot:default>
                      {{ item.has_item ? 'Available' : 'Not available' }}
                    </template>
                  </dot-status>
                </div>
                <div class="col-1">
                  {{ item.number }}
                </div>
                <div class="col-2">
                  {{ item.item_code }}
                </div>
                <div class="col-6">
                  {{ item.name }}
                </div>
                <div class="col-1">
                  {{ item.quantity }}
                </div>
                <div class="col-1">
                  <!-- icon if the item contains updates -->
                  <!-- <q-icon v-if="item.updates" name="mdi-alert-circle" color="orange" /> -->

                  <dot-status v-if="item.updates" class="q-ml-sm show-status--orange">
                    <template v-slot:default>
                      {{ getString(null, 'Updates available', 'Bijgewerkte versie beschikbaar') }}
                    </template>
                  </dot-status>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <q-modal v-model="itemModal" @hide="closeItemModal" :content-css="{ width: '800px', maxWidth: '100vw' }">
        <SparePartsDetailModal v-if="selectedItem" @update="updateItem" :reference="data.id" :item="selectedItem" @close="closeItemModal" />
      </q-modal>
    </div>
    <template v-if="!loading && !data.categories.length">
      <div class="row q-mb-lg">
        <div class="col-6" style="justify-content: flex-start">
          <q-btn class="capitalize ctrl-button" color="grey-5" :label="`${$store.state.stringsStore.strings.action.toOverview}`" @click="$router.push('/spare-parts')" icon="keyboard_backspace" />
        </div>
      </div>

      <div class="card-block full-width q-pa-md">
        <h4 class="text-center">{{ data.reference }}</h4>
        <p v-if="data.checked_at" class="text-center">{{ getString(null, 'There was a problem fetching the data for this reference. Please contact support.', 'Er is een probleem opgetreden bij het ophalen van de gegevens voor deze referentie. Neem alstublieft contact op met support. ') }}</p>
        <p v-else class="text-center">{{ getString(null, 'The data for the reference must still be fetched', 'De gegevens voor deze referentie moeten nog opgehaald worden.') }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import qs from 'qs';
import DotStatus from '@/components/status/DotStatus.vue';
import getString from '@/helpers/GetStrings';
import SparePartsDetailModal from './SparePartsDetailModal.vue';
import SparePartsLogsModal from './SparePartsLogsModal.vue';

export default {
  components: {
    DotStatus,
    SparePartsDetailModal,
    SparePartsLogsModal,
  },

  data() {
    return {
      loading: false,
      module: 'spareparts',
      readOnly: true,
      currentCategory: 0,
      itemModal: false,
      selectedItem: null,
      // Form data
      data: {
        item: null,
        categories: [],
        checked_at: null,
        created_at: null,
        external_id: null,
        id: null,
        is_active: null,
        reference: null,
      },
      logsModal: false,
    };
  },

  methods: {
    getString,

    getDetails() {
      return this.axios.get(`spareparts/${this.$route.params.id}`).then((res) => {
        this.data = res.data.reference;

        // cast is_active to number
        this.data.is_active = Number(this.data.is_active);
      });
    },

    async searchItems(terms, done) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`item?autocomplete=${terms.toLowerCase()}`);

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.items.map(item => ({
          label: item.code,
          id: item.id,
        }));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          done(suggested);
        }

        // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        done([]);
      }
    },

    selected(item, keyboard) {
      if (keyboard) return;

      this.data.item.id = item.id;
      this.data.item.code = item.label;

      this.inputField = '';
    },

    updateItem() {
      this.loading = true;
      this.getDetails().then(() => {
        this.selectedItem = null;
        this.itemModal = false;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    closeItemModal() {
      this.selectedItem = null;
      this.itemModal = false;
    },

    openItemModal(item) {
      this.selectedItem = item;
      this.itemModal = true;
    },

    selectCategory(index) {
      console.log('Selected category:', index);
      this.currentCategory = index;
    },

    save() {
      if (this.readOnly) {
        this.readOnly = false;
        return;
      }

      this.axios.put(`spareparts/${this.data.id}`, qs.stringify({
        item: this.data.item.id,
        active: Number(this.data.is_active),
      })).then(() => {
        this.$q.notify({
          message: 'Spare part saved successfully',
          position: 'top-right',
          timeout: 1000,
          color: 'positive',
        });
        this.readOnly = true;
      }).catch((error) => {
        console.error('Error saving spare part:', error);
        this.$q.notify({
          message: 'Error saving spare part',
          position: 'top-right',
          timeout: 1000,
          color: 'negative',
        });
      });
    }
  },

  computed: {
    itemCode: {
      get() {
        return this.data.item ? this.data.item.code : '';
      },
      set(value) {
        if (this.data.item) {
          this.data.item.code = value;
        } else {
          this.data.item = { code: value };
        }
      },
    },
    categoryImage: {
      get() {
        return `${process.env.VUE_APP_SITE}/storage/${this.data.categories[this.currentCategory].image}`;
      },
    },
  },

  mounted() {
    // Get data if the spare part already exists.
    if (this.$route.params.id) {
      this.getDetails().then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<style lang="stylus" scoped>
.spareparts-reference {
  &__row {
    line-height: 40px;
    &:nth-child(odd) {
      background-color: #fafafa;
    }
    &:hover {
      background-color: #f0f0f0;
      cursor pointer
    }
    &--header {
      background-color: #f0f0f0;
      font-weight: bold;
      padding 10px 0px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      position: sticky;
      top: -34px;
      z-index: 1;
    }
  }

  &__image {
    width: 100%;
    height: auto;
    border-radius: 5px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
  }

  &__left {
    position sticky;
    top: -34px;
  }

  &__category {
    background-color: #f0f0f0;
    padding: 10px;
    text-align: center;
    cursor: pointer;
    &:hover:not(.spareparts-reference__category--active) {
      background-color: #e0e0e0;
    }

    // fisrt and last child
    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    &:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    &--active {
      // background-color: #6CC6E3;
      background-color: #E76B66;
      font-weight: bold;
      color white
    }
  }
}

</style>
